class GoogleMapsService {
    // TODO: Replace with actual API call to backend
    // This should call: api.get('/api/google-maps/api-key')
    // The backend should return: { api_key: "your_google_api_key" }
    async getApiKey() {
        // TODO: Implement API call to backend to get Google Maps API key
        // const response = await api.get('/api/google-maps/api-key');
        // return response.api_key;
        
        // For development phase - using hardcoded key
        // TODO: Remove this hardcoded key when API endpoint is ready
        return 'AIzaSyC9TJzcMHt6o8KPC0zgXovKE_2JxWfNemg';
    }

    async initializeGoogleMaps() {
        try {
            const apiKey = await this.getApiKey();
            return this.loadGoogleMapsScript(apiKey);
        } catch (error) {
            console.error('Failed to initialize Google Maps:', error);
            throw error;
        }
    }

    loadGoogleMapsScript(apiKey) {
        return new Promise((resolve, reject) => {
            // Check if Google Maps is already loaded
            if (window.google && window.google.maps && window.google.maps.places) {
                resolve();
                return;
            }

            // Check if script is already being loaded
            if (document.querySelector('script[src*="maps.googleapis.com"]')) {
                // Script is already loading, wait for it
                const checkInterval = setInterval(() => {
                    if (window.google && window.google.maps && window.google.maps.places) {
                        clearInterval(checkInterval);
                        resolve();
                    }
                }, 100);
                
                // Timeout after 10 seconds
                setTimeout(() => {
                    clearInterval(checkInterval);
                    reject(new Error('Google Maps script loading timeout'));
                }, 10000);
                return;
            }

            // Set up global callback function
            window.initGoogleMaps = () => {
                // Wait a bit more to ensure Places API is fully ready
                setTimeout(() => {
                    if (window.google && window.google.maps && window.google.maps.places) {
                resolve();
                    } else {
                        reject(new Error('Google Maps Places API not ready after initialization'));
                    }
                }, 100);
            };

            // Create and load the script
            const script = document.createElement('script');
            script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=places&callback=initGoogleMaps&loading=async`;
            script.async = true;
            script.defer = true;
            script.onerror = () => {
                reject(new Error('Failed to load Google Maps script'));
            };
            
            document.head.appendChild(script);
        });
    }

    // Cleanup function to remove script and global callback
    cleanup() {
        if (window.initGoogleMaps) {
            window.initGoogleMaps = null;
        }
        
        // Remove any existing Google Maps scripts
        const scripts = document.querySelectorAll('script[src*="maps.googleapis.com"]');
        scripts.forEach(script => {
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
        });
        
        // Clear any Google Maps global objects
        if (window.google) {
            delete window.google;
        }
    }
}

export const googleMapsService = new GoogleMapsService(); 